'use client';

import { Box, ButtonBase, Link, type SxProps, Typography } from '@mui/material';
import { DisclosureTooltip } from '../../DisclosureTooltip';
import { factCheckedTooltipSx } from '../../disclosureTooltipPopover';

const BADGE_LABEL = 'Fact Checked';
const TOOLTIP_HEADING = 'How is this page expert verified?';
const TOOLTIP_PARAGRAPH =
  "NerdWallet's content is fact-checked for accuracy, timeliness and relevance. It undergoes a thorough review process involving writers and editors to ensure the information is as clear and complete as possible.";
const EDITORIAL_LINK_LABEL = 'More on our editorial rigor';
const EDITORIAL_LINK_HREF = 'https://www.nerdwallet.com/l/nerdwallet-editorial-guidelines';

export function FactCheckedBadge() {
  return (
    <DisclosureTooltip
      tooltipStyleOverride={factCheckedTooltipSx as SxProps}
      trigger={
        <ButtonBase
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            columnGap: 1,
            rowGap: 1,
            backgroundColor: 'blues.light',
            color: 'common.white',
            cursor: 'pointer',
            fontWeight: 500,
            lineHeight: 'normal',
            whiteSpace: 'nowrap',
            border: 'none',
            py: 1,
            px: 2,
            borderRadius: 1,
          }}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            focusable="false"
            fill="currentColor"
            style={{ flexShrink: 0 }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0Zm0 1.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z"
            />
            <path d="M9.78 4.72 6.25 8.25 4.22 6.22l.78-.78 1.25 1.25 2.75-2.75.78.78Z" />
          </svg>
          <Typography
            component="span"
            variant="textExtraSmall"
            sx={{ color: 'inherit', fontWeight: 500 }}
          >
            {BADGE_LABEL}
          </Typography>
        </ButtonBase>
      }
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Typography component="p" variant="textMediumBold" sx={{ color: 'common.black', m: 0 }}>
          {TOOLTIP_HEADING}
        </Typography>
        <Typography component="p" variant="textExtraSmall" sx={{ color: 'text.secondary', m: 0 }}>
          {TOOLTIP_PARAGRAPH}
        </Typography>
        <Link
          href={EDITORIAL_LINK_HREF}
          variant="textSmall"
          sx={{
            color: 'secondary.main',
            fontWeight: 700,
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          {EDITORIAL_LINK_LABEL}
        </Link>
      </Box>
    </DisclosureTooltip>
  );
}
